import * as angular from 'angular';
import * as _ from 'lodash';

import * as constants from '../../common/constants';

import { IAuthenticationService } from './';

export interface IAuthorizationService {
    isAuthenticated(): boolean;
    isConnected(): boolean;
    isSuperAdmin(): boolean;
    isInRole(role: string, userRoles?: string[]): boolean;
    isInRoles(roles: string[], userRoles?: string[]): boolean;
    canRead(): boolean;
    canEdit(): boolean;
    isCurrentUser(paramName: string, $stateParams: angular.ui.IStateParamsService): boolean;
    isUser(userName: string): boolean;
}

export class AuthorizationService implements IAuthorizationService {
    static serviceId = 'authorizationService';
    static $inject = [
        'authenticationService',
        '$state',
    ];

    constructor(
        private authenticationService: IAuthenticationService,
        private $state: angular.ui.IStateService
    ) {
    }

    isAuthenticated(): boolean {
        return !!this.authenticationService.authentication?.isAuth;
    }

    isConnected(): boolean {
        return this.authenticationService.authentication.isConnected;
    }

    isSuperAdmin(): boolean {
        return this.authenticationService.authentication.isSuperAdmin;
    }

    isInRole(role: string, userRoles?: string[]): boolean {
        userRoles = userRoles || this.authenticationService.authentication.roles;
        return userRoles.indexOf(role) > -1;
    }

    isInRoles(roles: string[], userRoles?: string[]): boolean {
        userRoles = userRoles || this.authenticationService.authentication.roles;
        const result = _.some(userRoles, r => roles.indexOf(r) > -1) ||
            (roles.indexOf(constants.Roles.superAdministrator) > -1 && this.isSuperAdmin());
        return result;
    }

    isUser(userName: string): boolean {
        const authUser = this.authenticationService.authentication.userName.toLowerCase();
        return (userName && authUser === userName?.toLowerCase());
    }

    canRead(): boolean {
        const roles = this.$state.current.data.readRoles;
        return this.isInRoles(roles);
    }

    canEdit(): boolean {
        const roles = this.$state.current.data.editRoles;
        const result = !roles || this.isInRoles(roles);
        return result;
    }

    isCurrentUser(paramName: string, $stateParams: angular.ui.IStateParamsService): boolean {
        const userName = this.authenticationService.authentication.userName.toLowerCase();
        const userNameParam = ($stateParams[paramName] as string).toLowerCase();
        return userName === userNameParam;
    }
}